// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__1YKcN","buttonsWrapper":"style_buttonsWrapper__8Z4jI"};